export default __webpack_public_path__ + "static/media/upload_data.6c09773f.svg";